import "./UserAE.css";
import { useEffect, useState } from "react";
import { ApplyIdentity, FetchIdentity, UsersFilter } from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function UserIdentity() {
  const [FormIdentity, setFormIdentity] = useState();
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const UsersFilterData = await UsersFilter({ id: id });
        if (UsersFilterData.status && UsersFilterData.status === 200) {
          setForm(UsersFilterData.data.data.data[0]);
          const FetchIdentityData = await FetchIdentity(id);
          if (FetchIdentityData.status && FetchIdentityData.status === 200) {
            setFormIdentity(FetchIdentityData.data.data);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  function handleChangeInputCheckBox(e) {
    let newFormIdentity = { ...FormIdentity };
    let checked = e.target.checked;
    let id = e.target.id;
    FormIdentity.userClaimValues.find(
      (Identity) => Identity.claimValue === id
    ).isSelected = checked;
    setFormIdentity(newFormIdentity);
  }

  const AddUpdate = async () => {
    setLoading(true);
    try {
      let FormIdentityCopy = { ...FormIdentity };
      FormIdentityCopy.userId = form.id;
      FormIdentityCopy.userName = form.userName;
      const ApplyIdentityData = await ApplyIdentity(FormIdentityCopy);
      if (ApplyIdentityData.status && ApplyIdentityData.status === 200) {
        toast.success("افزودن کاربر جدید با موفقیت انجام شد");
        navigate("/Panel/User");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <span className="m-3">
                {form.firstName +
                  " " +
                  form.lastName +
                  "(" +
                  form.userName +
                  ")"}
              </span>
            </div>
            <div className="d-flex justify-content-center align-items-center w-100 tableC">
              <table className="table">
                  <thead className="sticky-header">
                  <tr className="trTable">
                    {FormIdentity &&
                      FormIdentity.userClaimValues.map((item) => (
                        <th>{item.claimValuePersian}</th>
                      ))}
                  </tr>
                </thead>
                <tbody className="identitystyle">
                  <tr>
                    {FormIdentity &&
                      FormIdentity.userClaimValues.map((item) => (
                        <td>
                          <input
                            id={item.claimValue}
                            type="checkbox"
                            onChange={handleChangeInputCheckBox}
                            checked={item.isSelected}
                          />
                        </td>
                      ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button
                onClick={() => {
                  AddUpdate();
                }}
                className="butAU"
              >
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserIdentity;
